export default __webpack_public_path__ + "ef9f02939ccd772dc0d2aa037263d1bd.wav";